import React, { Fragment, useState } from 'react';
import { Button, Card, Col, Dropdown, Icon, Menu, Row } from 'antd';
import { convertArrayToObject, dateToString } from '../../../../utils';
import { GENDER } from '../../../../utils/const';
import CreateTicket from './CreateTicket';

export default ({ customer, showModal, gotoEdit, setReload }) => {

	const GENDER_OBJ = convertArrayToObject(GENDER, 'value', 'name');

	const [showModalCreateTicket, setShowModalCreateTicket] = useState(false);
	const [isIncome, setIsIncome] = useState(false);

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={10}>{label}</Col>
			<Col span={14}>: {value || '---'}</Col>
		</Row>
	);

	const menu = (<Menu>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => {
				setIsIncome(true);
				setShowModalCreateTicket(true);
			}}>
				Tạo phiếu thu
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => {
				setIsIncome(false);
				setShowModalCreateTicket(true);
			}}>
				Tạo phiếu chi
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={() => gotoEdit(customer.id)}>
				Cập nhật thông tin
			</a>
		</Menu.Item>
		<Menu.Item>
			<a target="_blank" rel="noopener noreferrer" onClick={showModal}>
				Xoá khách hàng
			</a>
		</Menu.Item>
	</Menu>);

	return <Fragment>
		<Card title={
			<div>
				<span>Thông tin khách hàng</span>
				<div style={{ float: 'right' }}>
					<Dropdown overlay={menu}>
						<Button type="primary" style={{ marginRight: 10 }}>
							Thao tác <Icon type="down" />
						</Button>
					</Dropdown>
				</div>
			</div>
		}>
			<Row>
				<Col span={12}>
					<InfoRow label="Tên khách hàng" value={customer.name} />
					<InfoRow label="Mã khách hàng" value={customer.customerCode} />
					<InfoRow label="Ngày sinh" value={dateToString(customer.dob)} />
					<InfoRow label="Giới tính" value={GENDER_OBJ[customer.gender] || '---'} />
				</Col>
				<Col span={12}>
					<InfoRow label="Số điện thoại" value={customer.phoneNumber} />
					<InfoRow label="Email" value={customer.email} />
					<InfoRow label="Địa chỉ cụ thể" value={customer.addressText} />
				</Col>
			</Row>
		</Card>
		<CreateTicket visible={showModalCreateTicket}
									setVisible={setShowModalCreateTicket}
									customerId={customer.id}
									isIncome={isIncome}
									callback={() => setReload(Math.random())}
		/>
	</Fragment>;
}
